import { Select } from './ui';
import { useAdminTeams, useCurrentUser } from '../hooks';
import { teamLabel } from '../lib/team';

interface Props {
  value: string | null;
  onChange: (team: string | null) => void;
  disabled?: boolean;
}

// Admins only: the server rejects a team change from anyone else.
export function TeamSelect({ value, onChange, disabled }: Props) {
  const { isAdmin } = useCurrentUser();
  const teams = useAdminTeams(isAdmin);
  if (!isAdmin) return null;

  const options = new Set(teams.data ?? []);
  if (value) options.add(value);
  return (
    <Select
      size="sm"
      value={value ?? ''}
      disabled={disabled || teams.isPending}
      onChange={(event) => onChange(event.target.value || null)}
      aria-label="Команда"
    >
      <option value="">Без команды</option>
      {[...options].sort().map((team) => (
        <option key={team} value={team}>
          {teamLabel(team)}
        </option>
      ))}
    </Select>
  );
}
